/* eslint-disable no-nested-ternary */

import useOfflineCentresStore from '@stores/offline-centres';
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { getIsLoggedIn, getFullName, getMePhone } from '@api/selectors/auth';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import PostPaymentForm from './PostPaymentForm';
import PPFStep2 from './PPFStep2';
import { OuterContainer, Container } from './styles';
import CentersCover from './CentersCover';
import LoginModal from './LoginModal';
import { modifyData, stepNumbers } from './utils';
import FormSubmittedCard from './FormSubmittedCard';

const PostPaymentLearnerDetails = ({ data }) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { postPaymentForm, setPostPaymentFormState } = useOfflineCentresStore();
  const { stepNum, isFormSubmitted } = postPaymentForm;
  const userFullName = useMyInfo(getFullName);
  const phoneNum = useMyInfo(getMePhone);
  const handleFormData = (formDetails) => {
    const { form_data: formData, is_form_submitted: isFormSubmittedAPI } =
      formDetails || {};
    if (formData) formData.isFormSubmitted = isFormSubmittedAPI;
    const modifiedData = modifyData(formData);
    setPostPaymentFormState({
      rollNumber: formDetails?.roll_number,
      ...modifiedData,
      fullName: formData?.fullName ? formData?.fullName : userFullName,
      phoneNum
    });
  };

  const updateStoreData = (fieldName, storeData) => {
    setPostPaymentFormState({ [fieldName]: storeData });
  };

  useEffect(() => {
    handleFormData(data);
  }, [isLoggedIn]);
  return (
    <>
      <OuterContainer>
        <Container>
          {isFormSubmitted ? (
            <FormSubmittedCard />
          ) : (
            <>
              <CentersCover />
              {isLoggedIn ? (
                stepNum === stepNumbers.ONE ? (
                  <PostPaymentForm
                    formState={postPaymentForm}
                    updateStoreData={updateStoreData}
                  />
                ) : (
                  <PPFStep2
                    formState={postPaymentForm}
                    updateStoreData={updateStoreData}
                  />
                )
              ) : (
                <LoginModal />
              )}
            </>
          )}
        </Container>
      </OuterContainer>
    </>
  );
};

export default PostPaymentLearnerDetails;
